import { render, staticRenderFns } from "./MessageModal.vue?vue&type=template&id=8b1b7b70&scoped=true"
import script from "./MessageModal.vue?vue&type=script&lang=js"
export * from "./MessageModal.vue?vue&type=script&lang=js"
import style0 from "./MessageModal.vue?vue&type=style&index=0&id=8b1b7b70&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1b7b70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b1b7b70')) {
      api.createRecord('8b1b7b70', component.options)
    } else {
      api.reload('8b1b7b70', component.options)
    }
    module.hot.accept("./MessageModal.vue?vue&type=template&id=8b1b7b70&scoped=true", function () {
      api.rerender('8b1b7b70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/modals/MessageModal.vue"
export default component.exports